import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

import { BENCHMARK_CONFIG_FRAGMENT } from './schema';

const QUERY = gql`
  query PerformanceCenterBenchmark($customerId: ID!, $assetType: AssetTypeEnum) {
    benchmarkConfig(customerId: $customerId, assetType: $assetType) {
      ...BenchmarkConfig
    }
  }
  ${BENCHMARK_CONFIG_FRAGMENT}
`;

export const queryPerformanceCenterBenchmark = ({ customerId, assetType }) => {
  return executeGqlQuery({
    query: QUERY,
    variables: {
      customerId,
      assetType,
    },
  }).then(({ data }) => getSingleProp(data));
};
